import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import { ArrowLeft, Eye, EyeOff } from 'lucide-react';

export default function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!phone || !password) { toast.error('Please fill all fields'); return; }
    setLoading(true);
    try {
      const data = await login(phone, password);
      toast.success(`Welcome back, ${data.user.name}!`);
      const role = data.user.role;
      if (role === 'parent') navigate('/parent', { replace: true });
      else if (role === 'admin') navigate('/admin', { replace: true });
      else navigate('/home', { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col px-4 py-8" style={{ background: '#FFF8F0' }}>
      <button data-testid="login-back-btn" onClick={() => navigate('/')} className="self-start mb-6">
        <ArrowLeft size={24} color="#1B4F8A" />
      </button>

      <div className="w-full max-w-md mx-auto">
        <div className="text-center mb-8">
          <a className="logo" href="#">
     
       <img src="assets/logo.png" alt="MathTopper Logo" className="mx-auto mb-2" style={{ width: '60px', height: '60px' }} />
      <h1 className="font-fredoka text-4xl md:text-5xl tracking-tight" style={{ color: '#FF6B35' }}>
            MathTopper
          </h1>
    </a>
          <h1 className="font-fredoka text-3xl" style={{ color: '#FF6B35' }}>Welcome Back!</h1>
          <p className="text-sm font-semibold mt-1" style={{ color: '#8B7355' }}>Login to continue your streak</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="text-sm font-bold block mb-1" style={{ color: '#1B4F8A' }}>Mobile Number</label>
            <div className="flex gap-2">
              <span className="bg-white border-2 rounded-2xl px-3 py-3 font-bold text-sm flex items-center" style={{ borderColor: '#E5DACE', color: '#1B4F8A' }}>+91</span>
              <input
                data-testid="login-phone-input"
                type="tel" value={phone} onChange={e => setPhone(e.target.value)}
                placeholder="9876543210" maxLength={10}
                className="flex-1 bg-white border-2 rounded-2xl px-4 py-3 font-bold text-sm outline-none focus:border-[#1B4F8A] focus:ring-4 focus:ring-[#1B4F8A]/20 transition-all"
                style={{ borderColor: '#E5DACE', color: '#1B4F8A' }}
              />
            </div>
          </div>

          <div>
            <label className="text-sm font-bold block mb-1" style={{ color: '#1B4F8A' }}>Password</label>
            <div className="relative">
              <input
                data-testid="login-password-input"
                type={showPw ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="w-full bg-white border-2 rounded-2xl px-4 py-3 font-bold text-sm outline-none focus:border-[#1B4F8A] focus:ring-4 focus:ring-[#1B4F8A]/20 transition-all pr-12"
                style={{ borderColor: '#E5DACE', color: '#1B4F8A' }}
              />
              <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-3.5" style={{ color: '#8B7355' }}>
                {showPw ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          <button
            data-testid="login-submit-btn"
            type="submit" disabled={loading}
            className="btn-press w-full py-4 rounded-full font-extrabold text-white text-base uppercase tracking-wide"
            style={{ background: '#FF6B35', boxShadow: '0 4px 0 #C04918', opacity: loading ? 0.7 : 1 }}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className="text-center mt-6">
          <button onClick={() => navigate('/forgot-password')} className="text-sm font-bold underline underline-offset-4 mb-3 block mx-auto" style={{ color: '#FF6B35' }} data-testid="forgot-password-link">
            Forgot Password?
          </button>
          <button onClick={() => navigate('/signup/student')} className="text-sm font-bold underline underline-offset-4" style={{ color: '#1B4F8A' }} data-testid="login-to-signup">
            Don't have an account? Sign up
          </button>
        </div>
      </div>
    </div>
  );
}
